import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * This is a map of all the people mentioned in the document
 * Used by the markdown serializer to map mention ids to mention names
 */

export var getMentionMap = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var node, getMentionNameDetails, mentionMapping, _findMentions;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          node = _ref.node, getMentionNameDetails = _ref.getMentionNameDetails;
          mentionMapping = {};
          _findMentions = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node) {
              var mentionNameDetails, promises;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!(node.type.name === 'mention')) {
                      _context.next = 5;
                      break;
                    }
                    _context.next = 3;
                    return getMentionNameDetails(node.attrs.id);
                  case 3:
                    mentionNameDetails = _context.sent;
                    if (mentionNameDetails) {
                      mentionMapping[node.attrs.id] = mentionNameDetails === null || mentionNameDetails === void 0 ? void 0 : mentionNameDetails.name;
                    }
                  case 5:
                    if (!node.content) {
                      _context.next = 10;
                      break;
                    }
                    promises = [];
                    node.content.forEach(function (child) {
                      promises.push(_findMentions(child));
                    });
                    _context.next = 10;
                    return Promise.all(promises);
                  case 10:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function findMentions(_x2) {
              return _ref3.apply(this, arguments);
            };
          }();
          _context2.next = 5;
          return _findMentions(node);
        case 5:
          return _context2.abrupt("return", mentionMapping);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getMentionMap(_x) {
    return _ref2.apply(this, arguments);
  };
}();